import React, { createContext, useContext, useMemo } from 'react';
import propTypes from 'prop-types';

const defaultValue = { isShrinked: false, isDarkPanel: false };

const SidebarNavContext = createContext(defaultValue);

/**
 * shares the sidebar panel's layout/theme flags with the nav pieces rendered inside it
 * @param isShrinked - whether the nav is collapsed to icons only
 * @param isDarkPanel - whether the panel sits on a dark background, so links invert to light text
 * @param children - the nav tree
 */
export function SidebarNavProvider({
  isShrinked,
  isDarkPanel = false,
  children
}) {
  const value = useMemo(
    () => ({ isShrinked, isDarkPanel }),
    [isShrinked, isDarkPanel]
  );
  return (
    <SidebarNavContext.Provider value={value}>
      {children}
    </SidebarNavContext.Provider>
  );
}

SidebarNavProvider.propTypes = {
  isShrinked: propTypes.bool,
  isDarkPanel: propTypes.bool,
  children: propTypes.node
};

export function useSidebarNav() {
  return useContext(SidebarNavContext);
}
